<template>
  <div>
    <k-layout>
      <k-flex c6 v-for="instance in instances" :key="instance.id">
        <item :id="instance.id"></item>
      </k-flex>
    </k-layout>
  </div>
</template>

<script>
import InstanceModel from '@/models/instance.js'
import Item from './videohub/Item'

export default {
  components: {
    Item
  },
  computed: {
    instances () {
      return _.filter(InstanceModel.instances_by_type("external_device"), (instance) => {
        return _.get(instance, "meta.type") == "blackmagic" && _.get(instance, "meta.device_config.type") == "videohub";
      });
    },
  }
}
</script>
